export const getVendorIdFromToken = () => {
  const storedToken = localStorage.getItem("token");
  if (!storedToken) return null;
  const tokenParts = storedToken.split(".");
  if (tokenParts.length !== 3) return null;
  try {
    const decodedPayload = JSON.parse(atob(tokenParts[1]));
    return decodedPayload?.id || null;
  } catch (error) {
    return null;
  }
};
